import queryString from "query-string"

export const buildContinueWithDestination = (): string => {
  const destination = `${window.location.pathname}${window.location.search}`
  return `/login/?continueWith=${encodeURIComponent(destination)}`
}

export const getContinueWith = (): string | null => {
  const { continueWith } = queryString.parse(window.location.search)
  // query-string yields an array when a param repeats; we only ever expect a
  // single continueWith, so collapse to the first string (or null).
  if (Array.isArray(continueWith)) {
    return continueWith.find((value): value is string => typeof value === "string") ?? null
  }
  return continueWith ?? null
}

export const buildContinueWithFromSearch = (): string => {
  const continueWith = getContinueWith()
  return continueWith ? `continueWith=${encodeURIComponent(continueWith)}` : ""
}
